"use client";

import { Feed } from "@/components/feed/feed";
import { PublicLandingPage } from "@/components/landing/public-landing-page";
import { useCurrentUser } from "@/hooks/use-current-user";

export function HomeRoute() {
  const currentUserQuery = useCurrentUser();

  if (currentUserQuery.data) {
    return (
      <Feed />
    );
  }

  if (currentUserQuery.isLoading) {
    return <div className="min-h-screen bg-white" />;
  }

  return <PublicLandingPage />;
}
